export default "__VITE_ASSET__BWwnT3aU__"